import React from 'react';
import '../styles/Modal.scss';

const Modal = ({ modalContent, closeModal }) => {
  if (!modalContent) return null;
  return (
    <div className="Modal">
      <div className="overlay" onClick={closeModal} />
      <div className="content">
        <div className="wrap">
          <div className="close" onClick={closeModal} />
          {modalContent}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  closeModal: React.PropTypes.func.isRequired,
  modalContent: React.PropTypes.object
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js